/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
function navbar(theme, ownerState) {
  const { palette, boxShadows, functions, transitions, breakpoints, borders } = theme;
  const { transparentNavbar, absolute, light, darkMode } = ownerState;

  const { dark, white, text, transparent, background } = palette;
  const { navbarBoxShadow } = boxShadows;
  const { rgba, pxToRem } = functions;
  const { borderRadius } = borders;

  return {
    boxShadow: transparentNavbar || absolute ? "none" : navbarBoxShadow,
    backdropFilter: transparentNavbar || absolute ? "none" : `saturate(200%) blur(${pxToRem(30)})`,
    backgroundColor:
      transparentNavbar || absolute
        ? `${transparent.main} !important`
        : rgba(darkMode ? background.default : white.main, 0.8),

    color: () => {
      let color;

      if (light) {
        color = white.main;
      } else if (transparentNavbar) {
        color = text.main;
      } else {
        color = dark.main;
      }

      return color;
    },
    top: absolute ? 0 : pxToRem(12),
    minHeight: pxToRem(75),
    display: "grid",
    alignItems: "center",
    borderRadius: borderRadius.xl,
    paddingTop: pxToRem(8),
    paddingBottom: pxToRem(8),
    paddingRight: absolute ? pxToRem(8) : 0,
    paddingLeft: absolute ? pxToRem(16) : 0,

    "& > *": {
      transition: transitions.create("all", {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& .MuiToolbar-root": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",

      [breakpoints.up("sm")]: {
        minHeight: "auto",
        padding: `${pxToRem(4)} ${pxToRem(16)}`,
      },
    },
  };
}

function navbarContainer(theme) {
  const { breakpoints, functions } = theme;
  const { pxToRem } = functions;

  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: pxToRem(75),
    [breakpoints.up("sm")]: {
      minHeight: pxToRem(65),
    },
    [breakpoints.up("lg")]: {
      minHeight: pxToRem(55),
    },
  };
}

function navbarRow(theme, { isMini }) {
  const { breakpoints } = theme;

  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    [breakpoints.up("xl")]: {
      width: isMini ? "100%" : "50%",
    },
  };
}

function navbarIconButton({ palette: { dark, white, text }, functions: { rgba } }) {
  return {
    color: dark.main,
    "&:hover": {
      backgroundColor: rgba(dark.main, 0.1),
    },
  };
}

function navbarMobileMenu(theme) {
  const { breakpoints, functions } = theme;
  const { pxToRem } = functions;

  return {
    display: "inline-flex",
    marginLeft: pxToRem(4),
    cursor: "pointer",
    [breakpoints.up("xl")]: {
      display: "none",
    },
  };
}

export { navbar, navbarContainer, navbarRow, navbarIconButton, navbarMobileMenu };
